const Util = {
  getMaxLength: function (blocks) {
    return blocks.reduce(function (previous, current) {
      return previous + current;
    }, 0);
  },
  getFormattedValue: function (value, blocks, blocksLength, delimiter, delimiters, delimiterLazyShow) {
    var result = "",
      multipleDelimiters = delimiters.length > 0,
      currentDelimiter = "";

    // no options, normal input
    if (blocksLength === 0) {
      return value;
    }

    blocks.forEach(function (length, index) {
      if (value.length > 0) {
        var sub = value.slice(0, length),
          rest = value.slice(length);

        if (multipleDelimiters) {
          currentDelimiter = delimiters[delimiterLazyShow ? index - 1 : index] || currentDelimiter;
        } else {
          currentDelimiter = delimiter;
        }

        if (delimiterLazyShow) {
          if (index > 0) {
            result += currentDelimiter;
          }

          result += sub;
        } else {
          result += sub;

          if (sub.length === length && index < blocksLength - 1) {
            result += currentDelimiter;
          }
        }

        // update remaining string
        value = rest;
      }
    });

    return result;
  },
  getDelimiterREByDelimiter: function (delimiter) {
    return new RegExp(delimiter.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1"), "g");
  }
};

const formatFns = {
  //左侧补字符
  padStart: function (value, char, length) {
    return (value || "").padStart(length, char);
  },
  //右侧补字符
  padEnd: function (value, char, length) {
    return (value || "").padEnd(length, char);
  },
  //大写
  upCase: function (value) {
    return (value || "").toUpperCase();
  },
  //小写
  lowCase: function (value) {
    return (value || "").toLowerCase();
  },
  //块分割
  block: function (value, blocks, delimiters=[]) {
    let blocksLength = blocks.length;
    if (dsf.isUnDef(delimiters)) {
      delimiters.push(" ");
    }
    if (dsf.isString(delimiters)) {
      delimiters = [delimiters];
    }
    let delimiter=" ";
    if (delimiters.length == 1) {
      delimiter = delimiters[0];
    }
    _.each(delimiters, (it) => {
      let delimiterRE = Util.getDelimiterREByDelimiter(it);
      value = value.replace(delimiterRE, "");
    });
    return Util.getFormattedValue(value, blocks, blocksLength, delimiter, delimiters);
  }
};


function format(command, value, args = []) {
  return formatFns[command].apply(null, [value, ...args]);
}
Object.assign(format, formatFns);

export default format;
